import { connect } from 'react-redux'
// For Lifecycle composing
// import {compose, lifecycle} from 'recompose'
import ModalWrapper from '../../components/modalWrapper/modalWrapperComponent'
import { State } from '../../redux/reducers/'
import { actionCreators } from '../../redux/reducers/ui/uiReducer'

export function mapStateToProps (state: State, props) {
  return {
    isOpen: state.ui.showTosModal
  }
}

export const propsMapping = {
  onRequestClose: actionCreators.toggleTosModal
}

export default connect(mapStateToProps, propsMapping)(ModalWrapper)

// export default compose(
//   connect(mapStateToProps, propsMapping),
//   lifecycle({
//     componentDidMount: function() {
//       if (this.props.fetchBasic) {
//         this.props.fetchBasic()
//       }
//     }
//   })
// )(TosDocsModal)



// WEBPACK FOOTER //
// ./src/containers/tosDocsModal/tosDocsModalContainer.js